import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const NAMES = [{
  name: 'María G.',
  city: 'Buenos Aires'
}, {
  name: 'Sofía L.',
  city: 'Córdoba'
}, {
  name: 'Valentina R.',
  city: 'Rosario'
}, {
  name: 'Camila M.',
  city: 'Mendoza'
}, {
  name: 'Lucía P.',
  city: 'La Plata'
}, {
  name: 'Martina S.',
  city: 'Mar del Plata'
}, {
  name: 'Julieta F.',
  city: 'Salta'
}, {
  name: 'Paula D.',
  city: 'Santa Fe'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState(NAMES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle through fake purchases
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomUser = NAMES[Math.floor(Math.random() * NAMES.length)];
        setCurrentUser(randomUser);
        setIsVisible(true);
      }, 2000); // Wait 2s before showing next one
    }, 15000); // Show every 15 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-40 max-w-xs w-full animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-194">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-100 p-4 flex items-start gap-3 relative" data-id="element-195">
        <button onClick={() => setIsVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600" data-id="element-196">
          <XIcon className="w-4 h-4" data-id="element-197" />
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-198">
          <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-199" />
        </div>

        <div data-id="element-200">
          <p className="text-sm font-bold text-gray-900" data-id="element-201">
            Nueva compra verificada
          </p>
          <p className="text-xs text-gray-600 mt-1" data-id="element-202">
            <span className="font-semibold" data-id="element-203">{currentUser.name}</span> de{' '}
            <span className="font-semibold" data-id="element-204">{currentUser.city}</span>
          </p>
          <p className="text-xs text-gray-500 mt-0.5" data-id="element-205">
            compró RESET CORPORAL 30D
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-206">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}